import ical from 'ical-generator';
import moment from 'moment-timezone';

export default (
  {
    title, datetime, timestamp, duration, location, uid,
  },
  timezone,
) => {
  const isoDatetime = datetime.replace(', ', 'T');
  const day = moment.tz(
    parseInt(moment.tz(isoDatetime, timezone).format('x'), 10),
    'UTC',
  );
  return ical({
    domain: window.location.hostname,
    prodId: '//Anand Chowdhary//Calendar Event Link//EN',
    events: [
      {
        start: moment(day),
        end: moment(day.add(duration, 'minutes')),
        summary: title,
        location,
        uid,
        timestamp: timestamp || moment(),
      },
    ],
  }).toString();
};
